// extracted by mini-css-extract-plugin
module.exports = {"fillBlue":"#5596f6","areaBlue":"#eef4fe","white":"#fff"};